export default __webpack_public_path__ + "static/media/start-k-9-thumb.5c4a8108.jpg";